// Resolución del rango temporal para el deep-link reporte → clasificador.
// Lógica pura: recibe el periodDataSelect como parámetro (no estado de Vue).

// ¿La fecha cae dentro del [from, to) de una option de periodDataSelect?
export function dateInRange(isoDate, option) {
    if (!isoDate || !option || !option.from || !option.to) return false;
    const date = new Date(isoDate + "T00:00:00");
    if (Number.isNaN(date.getTime())) return false;
    return option.from <= date && date < option.to;
}

// Rango más chico de periodDataSelect cuyo [from, to) contiene la fecha (las
// options vienen ordenadas de menor a mayor cobertura). Fallback "todo" para que
// el doc del deep-link aparezca aunque la fecha sea inválida o muy vieja.
export function pickRangeForDate(isoDate, periodDataSelect) {
    if (!isoDate) return "todo";
    const option = periodDataSelect.find((o) => dateInRange(isoDate, o));
    return option ? option.value : "todo";
}

// Respeta el rango pedido (modal 2) si contiene la fecha de emisión del doc; si
// no, expande al rango más chico que sí la contenga para que quede visible.
export function resolveClassifierRange(requestedRange, isoDate, periodDataSelect) {
    if (requestedRange) {
        const option = periodDataSelect.find((o) => o.value === requestedRange);
        if (option && dateInRange(isoDate, option)) return requestedRange;
    }
    return pickRangeForDate(isoDate, periodDataSelect);
}
